import { course_getCourseClassById_Api } from 'apis'
import { getId } from 'apis/model/base'
import _ from 'lodash'
import React, { useCallback, useRef } from 'react'
import { getResponseItem, renderIf } from 'views/Shared'
import useAsync from '../../../modules/asyncCache/useAsync'
import { gPaths } from '../configs'
import { bindQueryParam, mapPathParam } from '../functions/routerHelper'
import { PermissionEntity } from '../Permissions/PermissionEntity'
import CourseClassEntity from './CourseClass/CourseClassEntity'
import { courseClassRouteEntities } from './CourseClass/courseClassRouteEntities'

const CourseClassContext = React.createContext({})

export const CourseClassProvider = ({
  item,
  children,
  routePathField = 'path',
  routeEntities = courseClassRouteEntities,
  ...props
}) => {
  const formRef = useRef()

  const apiInfo = course_getCourseClassById_Api

  const id = getId(item) || item

  const cacheId = mapPathParam(apiInfo.path, { id })

  const { response, isLoading = false } = useAsync({
    apiInfo,
    query: bindQueryParam({ id }),
  })

  const isSucceed = Number(_.get(response, 'status')) === 200

  const cache = getResponseItem(response)

  const error = getResponseItem(response, 'error')

  const errorMessage = _.get(response, 'errorMessages.error')

  const error_code = _.get(response, 'errorMessages.error_code')

  const status = {
    title: getResponseItem(response, 'status'),
    description: errorMessage,
  }

  const defaultRoute = _.first(routeEntities)

  const getDefaultAction = (current) => {
    switch (current) {
      case gPaths.course_class:
        return _.get(defaultRoute, routePathField)
      default:
        return null
    }
  }

  const isValidRoute = useCallback(
    (route) => {
      return routeEntities
        .map((item) => _.get(item, routePathField))
        .includes(route)
    },
    [routeEntities, routePathField]
  )

  const renderHeader = useCallback((action, isModal) => null, [])

  const renderWarnings = useCallback((data) => {
    const warnings = Array.from(data ?? [])
    return renderIf(
      warnings.length,
      warnings.map((item, index) => {
        const { title, description } = item ?? {}
        return (
          <div
            key={index}
            className="flex flex-col gap-3 p-3 border border-dashed border-orange-500 rounded-lg">
            <div className="flex flex-col items-center">
              <div className="font-semibold text-sm text-orange-600">
                {title}
              </div>
              <div className="text-xs text-color-400 italic">{description}</div>
            </div>
          </div>
        )
      })
    )
  }, [])

  return (
    <CourseClassEntity
      key={cacheId}
      item={id}>
      {(item) => (
        <PermissionEntity item={item}>
          <CourseClassContext.Provider
            value={{
              id,
              formRef,
              isLoading,
              item,
              error,
              cache,
              status,
              isSucceed,
              error_code,
              renderHeader,
              errorMessage,
              defaultRoute,
              routeEntities,
              routePathField,
              isValidRoute,
              renderWarnings,
              getDefaultAction,
              ...props,
            }}>
            {children}
          </CourseClassContext.Provider>
        </PermissionEntity>
      )}
    </CourseClassEntity>
  )
}

export default CourseClassContext
